export namespace NotificationsInterfaces {

    /**
     * Конфигурация центрифуги
     */
    export interface CentrifugeConfig {
        url: string;
        user: string;
        timestamp: string;
        token: string;
        channels: string[];
    }

    export interface CentrifugeReceiveMessageResponse {
        channel: string;
        data: {
            action: string;
            messages: Message[];
        };
        uid: string;
    }

    export interface Message {
        id: number;
        title: string;
        body: string;
        type: NotificationsEnums.Type;
        created_at: number;
        is_read?: boolean;
        importance?: NotificationsEnums.Importance;
        extra: {
            links: ExtraLink[]
            data: string[]
        };

        date?: string;
        time?: string;
    }

    export interface ExtraLink {
        label: string;
        url: string;
    }

    /**
     * Группа уведомлений, сгруппированных по дате
     */
    export interface Group {
        date: string;
        items: Message[];
    }
}

export namespace NotificationsEnums {
    /**
     * Статус сообщения
     */
    export enum Status {
        new = 1,        // Новое
        read = 2,       // Прочитанное
    }

    /**
     * Тип уведомления
     */
    export enum Type {
        common = 1, // Обычное
        alert = 2,  // Срочное, показывается мгновенно при получении и больше не отображается
    }

    /**
     * Важность сообщения
     */
    export enum Importance {
        info = 1,       // Информационное
        warning = 2,    // Предупреждающее
    }
}

